<template>
    <div class="add-rate-orders">
        <a href="#" v-if="showRateButton" class="button mt-8 bg-secondary-200 hover:bg-blue-700 text-white" @click.prevent="openModalRate()">
            <span >{{ t('rate')}}</span>
        </a>
        <div :class="{'modal' : true , 'modalRate' : true , 'is-active' : isActiveRate }">
            <div class="modal-background bg-black opacity-50"></div>
            <div class="modal-card w-1/2 bg-white rounded-md">
                <div class="modal-header bg-secondary-300 flex justify-between">
                    <p class="text-white text-lg">{{ t('order_number') + order.receipt}}</p>
                    <button class="text-white focus:outline-none" aria-label="close" @click="closeModalRate">
                       <i class="fas fa-times-circle"></i>
                    </button> 
              </div>
              <section class="modal-body scrollbar-thumb-gray-500 scrollbar-track-gray-300 hover:scrollbar-thumb-gray-600 scrollbar-sm">
                <div class="p-8">
                 <div class="md:flex md:items-center mb-6">
                    <div class="md:w-1/5">
                        <label class="block text-gray-500 font-bold">
                            {{ t('leave_comment')}} 
                        </label>
                    </div>
                    <div class="md:w-4/5">
                        <star-rating v-model="rating" inputName="rating" :show-rating="false" :star-size="25" inactive-color="#fff" :border-width="4" border-color="#f8ba0a" active-color="#f8ba0a"></star-rating>
                    </div>
                </div>
                <div class="md:flex md:items-center mb-6">
                    <div class="md:w-full">
                        <textarea class="input block w-full text-primary placeholder-secondary-200" name="comment" v-model="comment" :placeholder="t('comment')" v-validate="{ required: true , min:10 ,max:255 }" :class="{'border-red-500': errors.has('comment') }"  rows="5"></textarea>
                        <p v-show="errors.has('comment')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('comment') }}</p>
                    </div>
                </div>

            </div>
        </section>
        <div class="modal-footer text-white text-lg">
            <button  @click.prevent="orderRate" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">{{ t('send') }}</button>
            <button @click="closeModalRate" class="bg-gray-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">{{ t('cancel')}}</button>
        </div>
    </div>
</div>
</div>

</template>

<script>
import StarRating from 'vue-star-rating/src/index';
import arabic from 'vee-validate/dist/locale/ar';
import axios from 'axios';
import trans from './translation/user.json';
import { Validator } from 'vee-validate';
export default {
    name: "AddRate",
    components:{
        StarRating
    },
    props: {
        order: {
            type: Object,
            required: true
        },
        siteLocale:{
            type: String,
            required: true
        },
    },
    data(){
        return {
            isActiveRate:false,
            rating: 0,
            comment: '',
            showRateButton: false
        };
    },
    mounted() {
        this.showRateButton = (this.order.rates.length == 0 && this.order.status_id == 5) ? true : false;
        this.$translate.setLang(this.siteLocale);
    },
    created () {
        this.$validator.localize('ar', {
            messages: arabic.messages,
            attributes: trans.ar,
            custom:trans.ar.custom
        });
        this.$validator.localize('en', {
            custom:trans.en.custom
        });

        Validator.localize(this.sitelocale);
    },
    locales: trans,
    methods:{
        controlModal(){
            this.isActive = !this.isActive;
        },
        openModalRate(){
            this.isActiveRate = true;
        },
        closeModalRate(){
            this.isActiveRate = false;
        },
        orderRate() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    axios.post(`/ar/orders/${this.order.id}/rate`, {
                        comment: this.comment,
                        rate: this.rating,
                        user_id: this.order.user_id
                    })
                    .then((response) => {
                        this.comment = '';
                        this.rating = 0;
                        this.showRateButton = false;
                        this.closeModalRate();
                        this.$toasted.success(response.data.message);
                    })
                    .catch(function (error) {
                        console.log(error);
                        let toaster = this.$toasted;
                        this.closeModalRate();
                        $.each(error.response.data.errors, function (key, value) {
                            toaster.error(value.message);
                        });
                    });
                }
            });
        }

    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/components/AddRate.vue